export default __webpack_public_path__ + "static/media/Invitacion_Beneficios_Museos_Publicable.0972e466.pdf";